import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { ContractorHeadCount, InterviewsStatus, vendorInfo } from '@interfaces/vendor-profile.model';
import { VendorEmployeeCount } from '@interfaces/vendor-management-model';
import { GlobalErrorService } from './global-error.service';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private baseUrl = environment.apiUrl;
  private cache: { [key: string]: any } = {};
  constructor(private http: HttpClient, private globalError: GlobalErrorService) {}

  getContractorHeadCount(vendorId: string, month: string, year: string): Observable<{ data: ContractorHeadCount[] }> {
    const url = `${this.baseUrl}/ops/contractors-headcount?vendorId=${vendorId}&month=${month}&year=${year}`;
    return this.http.get<{ data: ContractorHeadCount[] }>(url).pipe(
      catchError((error) => {
        this.globalError.logError(error);
        throw error;
      })
    );
  }

  getInterviewStatus(vendorId: string | null, month: string, year: string): Observable<{ data: InterviewsStatus }> {
    const url = `${this.baseUrl}/ops/candidate-interview-status?vendorId=${vendorId}&month=${month}&year=${year}`;
    return this.http.get<{ data: InterviewsStatus }>(url).pipe(
      catchError((error) => {
        this.globalError.logError(error);
        throw error;
      })
    );
  }

  getVendorData(vendorId: string | null): Observable<{ status: string; reason: string; data: vendorInfo[] }> {
    const url = `${this.baseUrl}/ops/vendor-information?vendorId=${vendorId}`;
    return this.http.get<{ status: string; reason: string; data: vendorInfo[] }>(url).pipe(
      catchError((error) => {
        this.globalError.logError(error);
        throw error;
      })
    );
  }

  updateVendorDetails(vendorInfo: Partial<vendorInfo>): Observable<vendorInfo> {
    const url = `${this.baseUrl}/vendor/update-profile`;
    return this.http.put<vendorInfo>(url, vendorInfo).pipe(
      catchError((error) => {
        return this.globalError.logError(error);
      }),
    );
  }

  updateVendorPocDetails(contactInfo: Partial<vendorInfo>): Observable<vendorInfo> {
    const url = `${this.baseUrl}/vendor/update-contact-card`;
    return this.http.put<vendorInfo>(url, contactInfo).pipe(
      catchError((error) => {
        return this.globalError.logError(error);
      }),
    );
  }
}
